/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import TableComponent from '../../components/TableComponent';
import { Store } from '../../types/General';

type props = {
  columns: any;
  rows: Store[];
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
};

const NewDealersStoreList = ({ rows, columns, count, page, onPageChange, loading }: props) => {
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default NewDealersStoreList;
